module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "mb-30"
  }, [_vm._v(_vm._s(_vm.$t("start.header")))])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn-tile start-campaign mb-20",
    on: {
      "click": function($event) {
        return _vm.redirect('new_crowdfunding')
      }
    }
  }, [_c('h3', {
    staticClass: "text-center mb-20"
  }, [_vm._v(_vm._s(_vm.$t("start.aProject")))]), _vm._v(" "), _c('h4', {
    staticClass: "text-center mb-20"
  }, [_c('sub', [_c('span', {
    staticClass: "logo-font domore-yellow"
  }, [_vm._v(_vm._s(_vm.$t("start.do")))]), _c('span', {
    staticClass: "logo-font domore-blue-1"
  }, [_vm._v(_vm._s(_vm.$t("start.more")))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t("start.projectDescription")))])]), _vm._v(" "), _c('h4', {
    staticClass: "domore-blue-2-light mb-20"
  }, [_vm._v(_vm._s(_vm.$t("start.projectFee")))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn-tile start-campaign mb-20",
    on: {
      "click": function($event) {
        return _vm.redirect('new_fundraising')
      }
    }
  }, [_c('h3', {
    staticClass: "text-center mb-20"
  }, [_vm._v(_vm._s(_vm.$t("start.aCause")))]), _vm._v(" "), _c('h4', {
    staticClass: "text-center mb-20"
  }, [_c('sub', [_c('span', {
    staticClass: "logo-font domore-yellow"
  }, [_vm._v(_vm._s(_vm.$t("start.do")))]), _c('span', {
    staticClass: "logo-font domore-blue-1"
  }, [_vm._v(_vm._s(_vm.$t("start.more")))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t("start.causeDescription")))])]), _vm._v(" "), _c('h4', {
    staticClass: "domore-blue-2-light mb-20"
  }, [_vm._v(_vm._s(_vm.$t("start.causeFee")))]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.showLogin) ? _c('login-modal', {
    attrs: {
      "close": _vm.closeLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-blue-1"
  }, [_vm._v("CROWDFUNDING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("FUNDRAISING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-50 mb-50"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aec99aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/StartCampaign.vue
// module id = 831
// module chunks = 1